module.exports = __webpack_public_path__ + "img/cloud-snow-moon.4a33dd2b.svg";